export default __webpack_public_path__ + "static/media/licLogo.623be167.png";